import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import config from 'root/main/components/navigation/navigation_config';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import navTracking from 'root/utils/tracking/GA4/navigation/navTracking';

const cm = new CookieMonster();
const btCookieName = 'ls_vertical_bt';

const navHeader = document.querySelector('header.main-site-header-btf');
const mobileSecondaryNav = document.querySelector(
    '[data-navigation-btf-mobile="header-secondary"]'
);
const navContainer = document.querySelector('[data-navigation-btf-mobile=container]');
const secondaryNav = document.querySelector(
    '[data-navigation-btf-mobile=menu-secondary]'
);

/*
 * This adds or removes the "hidden" class from the "clear-cookie" element of the secondary nav
 * the "clear-cookie" element is the "Not a --- store?" found at the bottom of the secondary nav on mobile
 * The addOrRemoveHiddenClass param accepts the strings "add" or "remove" as values
 * @param addOrRemoveHiddenClass
 * */
const toggleBtfClearCookiesElsDisplay = addOrRemoveHiddenClass => {
    if (typeof addOrRemoveHiddenClass === 'string') {
        const secondaryNavClearButtons = mobileSecondaryNav.querySelectorAll(
            '[data-secondary-nav-clear-bt]'
        );
        if (secondaryNavClearButtons) {
            secondaryNavClearButtons.forEach(secondaryNavClearButton => {
                secondaryNavClearButton.parentElement.classList[addOrRemoveHiddenClass](
                    'navigation-btf-mobile__item--hidden'
                );
            });
        }
        const secondaryNavLines = mobileSecondaryNav.querySelectorAll(
            '[data-secondary-nav-line]'
        );
        if (secondaryNavLines) {
            secondaryNavLines.forEach(secondaryNavLine => {
                secondaryNavLine.classList[addOrRemoveHiddenClass](
                    'navigation-btf-mobile__item__dividing-line--hidden'
                );
            });
        }
    }
};

const personalizeSecondaryMobileNav = () => {
    if (
        mobileSecondaryNav &&
        mobileSecondaryNav.classList.contains('navigation-btf-mobile__secondary')
    ) {
        /* Setting the cookie and populating the nav values is being handled by a script inserted at the end of the
         * html/wp-content/themes/ls/views/Section/navigation/btf/layout/desktop_secondary.html.twig
         * slugMatch: rather then calling the btfNavSecondaryLexic global variable we set a data attribute on the header container of the nav and we check its value here
         *  */

        // slugMatch returns a string from a data attribute with the value of "true" or "false"
        const slugMatch = navHeader.dataset.slugMatch;

        if (slugMatch === 'true') {
            const secondaryNavClearButtons = mobileSecondaryNav.querySelectorAll(
                '[data-secondary-nav-clear-bt]'
            );
            if (secondaryNavClearButtons) {
                secondaryNavClearButtons.forEach(secondaryNavClearButton => {
                    secondaryNavClearButton.addEventListener('click', () => {
                        cm.unsetCookie(btCookieName);
                        navigator.cookieEnabled &&
                            window.localStorage?.removeItem(
                                'btf.businessType'
                            ); /* we are checking for localStorage because localStorage is not available on some mobile browsers */
                    });
                });
                toggleBtfClearCookiesElsDisplay('remove');
            }

            const btfNavClearBtCookieEls = document.querySelectorAll(
                '[data-btf-nav-clear-cookie]'
            );
            if (btfNavClearBtCookieEls) {
                btfNavClearBtCookieEls.forEach(btfNavClearBtCookieEl => {
                    btfNavClearBtCookieEl.addEventListener('click', () => {
                        cm.unsetCookie(btCookieName);
                        navigator.cookieEnabled &&
                            window.localStorage?.removeItem('btf.businessType');
                    });
                });
            }
        } else {
            toggleBtfClearCookiesElsDisplay('add');
            cm.unsetCookie(btCookieName);
            navigator.cookieEnabled &&
                window.localStorage?.removeItem('btf.businessType');
        }
    }
};

const sendNavClickEventsToGTM = () => {
    if (secondaryNav) {
        secondaryNav.addEventListener('click', e => {
            if (e.target.hasAttribute(config.navigation_link_attribute)) {
                gtm.secondaryMenu(e.target).sendEvent('click');

                const GTMObject = navTracking(e.target);
                GTMObject && GoogleTagManager.sendEvent(GTMObject);
            }
        });
    }
    navContainer.addEventListener('click', e => {
        if (e.target.hasAttribute(config.navigation_link_attribute)) {
            gtm.menu(e.target).sendEvent('click');

            const GTMObject = navTracking(e.target);
            GTMObject && GoogleTagManager.sendEvent(GTMObject);
        }
    });
};

export { personalizeSecondaryMobileNav, sendNavClickEventsToGTM };
